"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DATE_FORMAT_FR: function() {
        return DATE_FORMAT_FR;
    },
    DATE_FORMAT_NO_YEAR_FR: function() {
        return DATE_FORMAT_NO_YEAR_FR;
    },
    DATE_NUMERIC_FR_FORMAT: function() {
        return DATE_NUMERIC_FR_FORMAT;
    },
    MONTH_DATE_FORMAT_FR: function() {
        return MONTH_DATE_FORMAT_FR;
    },
    V1_DATE_TIME_FORMAT: function() {
        return V1_DATE_TIME_FORMAT;
    },
    V2_DATE_TIME_FORMAT: function() {
        return V2_DATE_TIME_FORMAT;
    },
    formatApiDate: function() {
        return formatApiDate;
    },
    formatDate: function() {
        return formatDate;
    },
    formatDateDescriptive: function() {
        return formatDateDescriptive;
    },
    formatDateNumeric: function() {
        return formatDateNumeric;
    },
    formatDateTime: function() {
        return formatDateTime;
    },
    formatDateTimeNoYear: function() {
        return formatDateTimeNoYear;
    },
    formatDateTimeNumeric: function() {
        return formatDateTimeNumeric;
    },
    formatDayMonthDate: function() {
        return formatDayMonthDate;
    },
    formatHourMinute: function() {
        return formatHourMinute;
    },
    formatHourRange: function() {
        return formatHourRange;
    },
    formatMonthDate: function() {
        return formatMonthDate;
    },
    formatShortDate: function() {
        return formatShortDate;
    },
    formatShortDay: function() {
        return formatShortDay;
    },
    formatTimestamp: function() {
        return formatTimestamp;
    },
    formatUpcomingJobRange: function() {
        return formatUpcomingJobRange;
    },
    formatV1DateTime: function() {
        return formatV1DateTime;
    },
    formatV2DateTime: function() {
        return formatV2DateTime;
    }
});
const _dateconstants = require("./date.constants");
const V1_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const V2_DATE_TIME_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
const DATE_FORMAT_FR = 'D MMM YYYY';
const DATE_FORMAT_NO_YEAR_FR = 'D MMM';
const MONTH_DATE_FORMAT_FR = 'D MMM';
const DATE_NUMERIC_FR_FORMAT = 'YYYY-MM-DD';
const formatApiDate = (moment)=>{
    return moment.format(_dateconstants.API_DATE_FORMAT);
};
const formatV1DateTime = (moment)=>{
    return moment.format(V1_DATE_TIME_FORMAT);
};
const formatV2DateTime = (moment)=>{
    return moment.format(V2_DATE_TIME_FORMAT);
};
const formatHourRange = (start, end)=>{
    return `${start.format(_dateconstants.TIME_FORMAT)}${_dateconstants.EN_DASH}${end.format(_dateconstants.TIME_FORMAT)}`;
};
const formatDate = (moment)=>{
    if (moment.locale() === 'fr') {
        return moment.format(DATE_FORMAT_FR);
    }
    return moment.format(_dateconstants.DATE_FORMAT);
};
const formatDateTime = (moment)=>{
    if (moment.locale() === 'fr') {
        return moment.format(`${DATE_FORMAT_FR}, ${_dateconstants.TIME_FORMAT}`).replace('.', '');
    }
    return moment.format(`${_dateconstants.DATE_FORMAT}, ${_dateconstants.TIME_FORMAT}`);
};
const formatDateTimeNoYear = (moment)=>{
    if (moment.locale() === 'fr') {
        return moment.format(`${DATE_FORMAT_NO_YEAR_FR}, ${_dateconstants.TIME_FORMAT}`).replace('.', '');
    }
    return moment.format(`${_dateconstants.DATE_FORMAT_NO_YEAR}, ${_dateconstants.TIME_FORMAT}`);
};
const formatDateNumeric = (moment)=>{
    if (moment.locale() === 'fr') {
        return moment.format(DATE_NUMERIC_FR_FORMAT);
    }
    return moment.format(_dateconstants.DATE_NUMERIC_FORMAT);
};
const formatDateTimeNumeric = (moment)=>{
    if (moment.locale() === 'fr') {
        return moment.format(`${DATE_NUMERIC_FR_FORMAT}, ${_dateconstants.TIME_FORMAT}`);
    }
    return moment.format(`${_dateconstants.DATE_NUMERIC_FORMAT}, ${_dateconstants.TIME_FORMAT}`);
};
const formatShortDate = (moment)=>{
    return moment.format(_dateconstants.DATE_SHORT_FORMAT);
};
const formatDayMonthDate = (moment)=>{
    return moment.format(_dateconstants.DAY_MONTH_DATE_FORMAT);
};
const formatShortDay = (moment)=>{
    return moment.format(_dateconstants.DAY_SHORT_FORMAT);
};
const formatHourMinute = (moment)=>{
    return moment.format(_dateconstants.TIME_FORMAT);
};
const formatTimestamp = (moment)=>{
    return moment.format(_dateconstants.UNIX_TIMESTAMP_FORMAT);
};
const formatMonthDate = (moment)=>{
    if (moment.locale() === 'fr') {
        return moment.format(MONTH_DATE_FORMAT_FR).replace('.', '');
    }
    return moment.format(_dateconstants.MONTH_DATE_FORMAT);
};
const formatUpcomingJobRange = (moment)=>{
    const date = moment.format(_dateconstants.MONTH_DATE_FORMAT);
    const timeRangeMin = moment.format(_dateconstants.TIME_FORMAT);
    const timeRangeMax = moment.clone().add(1, 'hour').format(_dateconstants.TIME_FORMAT);
    return `${date}, ${timeRangeMin}${_dateconstants.EN_DASH}${timeRangeMax}`;
};
const formatDateDescriptive = (moment, today, format = (moment)=>formatDateNumeric(moment))=>{
    if (moment.isSame(today, 'day')) {
        return 'Today';
    }
    if (moment.isSame(today.clone().subtract(1, 'day'), 'day')) {
        return 'Yesterday';
    }
    if (moment.isSame(today.clone().add(1, 'day'), 'day')) {
        return 'Tomorrow';
    }
    return format(moment);
};

//# sourceMappingURL=date-moment.js.map